module.exports = __webpack_public_path__ + "img/share-instagram-icon.1e005978.svg";